import React from 'react';
import PropTypes from 'prop-types';

import Logo from 'Components/Shared/Logo/Logo';

import './Address.module.css';

import KssLogo from 'Images/kss-logo.png';

Address.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
  }).isRequired,
};

function Address({ data }) {
  return (
    <section styleName="Address">
      <Logo />
      <div>
        { data.name }<br />
        { data.street }<br />
        { data.postcode } { data.city }<br />
        Tel.: { data.phone }<br />
        <a href={`mailto:${data.mail}`}>{ data.mail }</a>
      </div>
      <div styleName="kssGroup">
        Member of <a target="_blank" href="http://www.kss-handel.at/home/"><img src={KssLogo} alt="KSS Logo" /></a> Group
      </div>
    </section>
  );
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/Footer/Address.js